<template>
  <div
    class="relative pt-16 pb-32 flex content-center items-center justify-center"
    style="min-height: 75vh;"
  >
    <div class="absolute top-0 w-full h-full bg-center bg-cover bannerBackground">
      <span id="blackOverlay" class="w-full h-full absolute opacity-75 bg-black"></span>
    </div>
    <div class="container relative mx-auto">
      <div class="items-center flex flex-wrap">
        <div class="w-full lg:w-10/12 px-4 ml-auto mr-auto text-center">
          <div class="pr-8">
            <vue-typed-js
              id="head"
              class="flex text-center w-full"
              :style="{justifyContent:'center'}"
              :loop="true"
              :smartBackspace="false"
              :startDelay="200"
              :typeSpeed="60"
              :backDelay="2000"
              :backSpeed="10"
              :cursorChar="'_'"
              :loopCount="3"
              :strings="['Ihr Webprojekt', 'Ihre Mobile App', 'Ihre Projektidee']"
            >
              <h1
                class="text-white font-semibold text-5xl sm:text-xl md:text-3xl lg:text-5xl xl:text-4xl"
              >
                Der Partner für
                <span class="typing"></span>
              </h1>
            </vue-typed-js>
            <p class="mt-4 text-lg text-gray-300">{{subtitle}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden"
      style="height: 70px; transform: translateZ(0px);"
    >
      <angled-s-v-g colorClass="text-gray-300"></angled-s-v-g>
    </div>
    
  </div>
</template>

<script>
import AngledSVG from "../components/Base/AngledSVG.vue";

export default {
  components: {
    AngledSVG
  },
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    }
  }
};
</script>

<style>
.bannerBackground {
  background-image: url("../assets/img/bck.jpg");
}
h1 {
  /* font-family: 'Quicksand', sans-serif; */
  /* font-family: 'Archivo Narrow', sans-serif; */
  font-family: "Ubuntu", sans-serif;
  font-weight: 700;
}
</style>